var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessRate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 62.3047V69.2152C42.4839 70.6713 42.0941 72.0989 41.3677 73.3611C40.6414 74.6233 39.6029 75.6777 38.352 76.4232C35.6964 78.3901 33.5361 80.9494 32.0428 83.8975C30.5496 86.8457 29.7645 90.1015 29.75 93.4062",
    stroke: "url(#paint0_linear_971_1694)",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5 62.3047V69.2152C59.5161 70.6713 59.9059 72.0989 60.6323 73.3611C61.3586 74.6233 62.3971 75.6777 63.648 76.4232C66.3036 78.3901 68.4639 80.9494 69.9572 83.8975C71.4504 86.8457 72.2355 90.1015 72.25 93.4062",
    stroke: "url(#paint1_linear_971_1694)",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5 38.25H82.875C85.6929 38.25 88.3954 37.1306 90.388 35.138C92.3806 33.1454 93.5 30.4429 93.5 27.625C93.5 24.8071 92.3806 22.1046 90.388 20.112C88.3954 18.1194 85.6929 17 82.875 17H76.5",
    stroke: "url(#paint2_linear_971_1694)",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 93.5H85",
    stroke: "url(#paint3_linear_971_1694)",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 38.25C25.5 45.013 28.1866 51.499 32.9688 56.2812C37.751 61.0634 44.237 63.75 51 63.75C57.763 63.75 64.249 61.0634 69.0312 56.2812C73.8134 51.499 76.5 45.013 76.5 38.25V12.75C76.5 11.6228 76.0522 10.5418 75.2552 9.7448C74.4582 8.94777 73.3772 8.5 72.25 8.5H29.75C28.6228 8.5 27.5418 8.94777 26.7448 9.7448C25.9478 10.5418 25.5 11.6228 25.5 12.75V38.25Z",
    stroke: "url(#paint4_linear_971_1694)",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 38.25H19.125C16.3071 38.25 13.6046 37.1306 11.612 35.138C9.61942 33.1454 8.5 30.4429 8.5 27.625C8.5 24.8071 9.61942 22.1046 11.612 20.112C13.6046 18.1194 16.3071 17 19.125 17H25.5",
    stroke: "url(#paint5_linear_971_1694)",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_971_1694",
    x1: 36.125,
    y1: 62.3047,
    x2: 36.125,
    y2: 93.4062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2853D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2853D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_971_1694",
    x1: 65.875,
    y1: 62.3047,
    x2: 65.875,
    y2: 93.4062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2853D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2853D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_971_1694",
    x1: 85,
    y1: 17,
    x2: 85,
    y2: 38.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2853D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2853D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_971_1694",
    x1: 51,
    y1: 93.5,
    x2: 51,
    y2: 94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2853D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2853D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_971_1694",
    x1: 51,
    y1: 8.5,
    x2: 51,
    y2: 63.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2853D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2853D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_971_1694",
    x1: 17,
    y1: 17,
    x2: 17,
    y2: 38.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2853D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2853D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessRate);
export default __webpack_public_path__ + "static/media/SuccessRate.6c21df121282b41a4231ad5e4347aaa2.svg";
export { ForwardRef as ReactComponent };